import React, { useState, useEffect, useCallback } from "react";
import { Form, Button, Select, DatePicker, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import * as zoneActions from "../../../../redux/actions/zone.actions";
import * as performanceActions from "../../../../redux/actions/performance.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { swalNotification } from "../../../../components/alret/notificztion";

const { RangePicker } = DatePicker;

const PerformanceFilter = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  
  useEffect(() => {
    if (props.formData){
      form.setFieldsValue(props.formData || null);
    }
  }, [props.formData])

  useEffect(() => {
    postLists()
  }, []);

  const postLists = useCallback(async() => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }, [])
  
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item) => {zoneData.push({value: item?.id, label: item?.zoneName})});
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);

  const filterChange = useCallback(async (value) => {
    if(!value.zone && !value.riderId){
      swalNotification("Select zone or riderId first!", "", "error");
    }
    const pageData = {
      ...props.formData,
      ...value,
      page: 1,
    };
    await props.performanceActions.filterPerformanceAction(pageData);
  },[])

  return (
    <Form form={form} className="custom-form" disabled={loading || props?.pageLoader} onFinish={filterChange} layout="vertical" name="form_in_modal" initialValues={{ modifier: 'public', }}>
      <Form.Item
       name={["date"]}
       label={"Date"}
      >
        <RangePicker
          allowClear={false}
          // showTime={{ format: 'HH:mm' }}
          // format="YYYY-MM-DD HH:mm"
          format="YYYY-MM-DD"
        />
      </Form.Item>
      <Form.Item
       name={["zone"]}
       label={(<>Search Zone</>)}
      //  rules={[{required: true, message: 'Please select zone'}]}
      >
        <Select
          showSearch
          allowClear
          optionFilterProp="children"
          // mode="multiple"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          style={{ minWidth: 300,}}
        />
      </Form.Item>
      <Form.Item
       name={["riderId"]}
       label={(<>Rider ID</>)}
      >
        <Input
          placeholder=""
        />
      </Form.Item>
      <Button htmlType="submit" disabled={loading || props?.pageLoader}>Search <SearchOutlined /></Button>
      {/* <Button onClick={()=>filterreset()}>Reset</Button> */}
    </Form>
  );
};

const mapStateToProps = (state) => {
  return { 
    zoneData: state.ZoneReducer.zoneData,
    formData: state.PerformanceReducer.performanceFilter,
    pageLoader: state.PerformanceReducer.performanceLoader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    performanceActions: bindActionCreators(performanceActions, dispatch),
  };
};



export default connect(mapStateToProps, mapDispatchToProps)(PerformanceFilter);

